<template>
  <div>
    <div class="header">
      <h4>
        {{ nome }}
      </h4>

      <h4>
        <span>
          <template v-if="credenciados.length == 0">
            Nenhum resultado
          </template>
          <template v-else-if="credenciados.length == 1">
            1 resultado
          </template>
          <template v-else>
          {{ credenciados.length }} resultados
          </template>
        </span>
      </h4>
    </div>

    <div class="detail">
      <Func4PrintDetail v-for="credenciado in credenciados" :key="credenciado.id" :credenciado="credenciado" />
    </div>
  </div>
</template>

<script>
import Func4PrintDetail from '@/views/4/print/PrintDetail'

export default {
  name: 'Func4PrintGroup',
  components: { Func4PrintDetail },
  props: {
    nome: {},
    credenciados: []
  }
}
</script>

<style scoped lang="less">
.header {
  display: flex;
  justify-content: space-between;
  background: lightgrey;
  padding: 8px;
  border-bottom: 2px solid dimgrey;
}

.detail {
  display: grid;
  grid-template-columns: 50% 50%;
}
</style>
